import React, { useState } from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  FDStack, FDBox, FDSecondaryActionButton, FDAlert,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import PlannerInformationPicker
  from 'Views/Page/Content/Templates/PlannerTransitionHouseholdTemplate/Content/PlannerTransitionTableFilters/PlannerInformationPicker';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useSnackbarContext } from 'Context/SnackbarContext';

const Layout = ({ onSubmit, plannerTransitionCollectionLoading }) => {
  const { pageContentCollection } = usePageContentContext();
  const { resource, handleChange } = useMetaLayoutContext();
  const { displayErrorMessage } = useSnackbarContext();
  const [filterUpdatingCollection, setFilterUpdatingCollection] = useState(false);
  const isLoading = plannerTransitionCollectionLoading || filterUpdatingCollection;

  // If an agent is selected and there are records for that agent. Show the agent card
  const showAgentInfo = !resource.isAttrEmpty('previousLeadPlannerId') && pageContentCollection?.resources()?.list()?.length > 0;

  const handleFilterSubmit = async () => {
    setFilterUpdatingCollection(true);
    try {
      await onSubmit();
    } catch (err) {
      if (err.errors) {
        displayErrorMessage(err, err.errors);
      } else {
        displayErrorMessage(err, 'Error: Failed to filter planner transition households.');
      }
    } finally {
      setFilterUpdatingCollection(false);
    }
  };

  return (
    <FDStack direction={'row'} spacing={1} alignItems={'center'} wrap justifyContent="flex-start">
      <FDStack direction={'row'} spacing={2} alignItems={'center'} wrap justifyContent="flex-start">
        {resource.meta().template().list().filter(field => field.attr('type') === 'picklist')
          .map((field) => {
            return (
              <FDBox width={'250px'} key={field.attr('name')}>
                <MetaControlField
                  attr={field.attr('name')}
                  resource={resource}
                  onInlineSubmit={handleFilterSubmit}
                />
              </FDBox>
            );
          })}
        {resource.meta().template().list().filter(field => field.attr('type') === 'multipicklist')
          .map((field) => {
            return (
              <FDBox width={'250px'} key={field.attr('name')}>
                <MetaControlField
                  attr={field.attr('name')}
                  resource={resource}
                  onInlineSubmit={handleFilterSubmit}
                  SelectProps={{
                    onClose: handleFilterSubmit,
                  }}
                />
              </FDBox>
            );
          })}
        {resource.meta().template().list().filter(field => field.attr('type') === 'bool')
          .map((field) => {
            return (
              <MetaControlField
                key={field.attr('name')}
                attr={field.attr('name')}
                resource={resource}
                onInlineSubmit={handleFilterSubmit}
                checked={resource.isTruthy(field.attr('name'))}
              />
            );
          })}
        { showAgentInfo ? (
          <PlannerInformationPicker
            resource={pageContentCollection.resources().head()}
            direction={'row'}
          />
        ) : null}
        <FDSecondaryActionButton
          icon={'close'}
          label={'Clear Filters'}
          size={'sm'}
          onClick={() => {
            resource.meta().template().list().forEach(metaField => {
              handleChange(metaField.attr('name'), '');
            });
            return handleFilterSubmit();
          }}
        />
        <FDAlert status={isLoading ? 'warning' : 'success'} title={isLoading ? 'Updating...' : 'Up To Date'} />
      </FDStack>
    </FDStack>
  );
};

Layout.defaultProps = {
  onSubmit: null,
  plannerTransitionCollectionLoading: false,
};

Layout.propTypes = {
  onSubmit: PropTypes.func,
  plannerTransitionCollectionLoading: PropTypes.bool,
};

export default Layout;
